import { Text, VStack } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import FileGridLoader from './FileGridLoader'
import FolderGridLoader from './FolderGridLoader'
import CollectionGridSkeleton from './CollectionGridSkeleton'
import Heading from './Heading'
const MLGridLoader = ({
  scrollEl,
  isSearchPage = false,
}: {
  scrollEl: HTMLDivElement | null
  isSearchPage?: boolean
}): ReactElement | null => {
  const { t } = useTranslation()
  return (
    <VStack padding={'24px'} alignItems="flex-start" spacing="0px">
      <Fragment>
        <Heading name={t('folders', 'Folders')} isFirst={true} />
        <FolderGridLoader scrollEl={scrollEl} />
      </Fragment>
      <Fragment>
        <Heading name={t('files', 'Files')} />
        <FileGridLoader scrollEl={scrollEl} />
      </Fragment>
      {isSearchPage && (
        <Fragment>
          <Heading name={t('media_collections', 'Media collections')} />

          <CollectionGridSkeleton scrollEl={scrollEl} />
        </Fragment>
      )}
    </VStack>
  )
}

export default MLGridLoader
